const filter = [
  {
    service: {
      folder: 'bibliotecas',
      file: 'Bibliotecas',
      relationship: ''
    },
    listLabel: 'biblioteca',
    label: 'Biblioteca',
    itemValue: 'id',
    itemText: 'apelido',
    id: 'biblioteca_id'
  },
  {
    service: {
      folder: 'obras',
      file: 'FormatosExemplares',
      relationship: ''
    },
    listLabel: 'formato',
    label: 'Formato',
    itemValue: 'id',
    itemText: 'descricao',
    id: 'formato_exemplar_id'
  }
]

export default filter
